<template>
  <div class="card shadow">
    <div class="card-header">
      Comments
    </div>
    <div v-loading="loading">
      <table class="table">
        <thead class="thead-light">
          <tr>
            <th>Last Comment</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="comment in comments" :key="comment.id">
            <td>
              <div v-if="comment.recipe" class="mb-3">
                <strong><a :href="`https://www.nyonyacooking.com/recipes/${ comment.recipe.slug }~${ comment.recipe.id }`" target="_blank">{{ comment.recipe.title }}</a></strong>
              </div>
              <div v-if="comment.product" class="mb-3">
                <strong><a :href="`https://www.nyonyacooking.com/store/${ comment.product.slug }~${ comment.product.id }`" target="_blank">{{ comment.product.title }}</a></strong>
              </div>
              <div v-if="comment.article" class="mb-3">
                <strong><a :href="`https://www.nyonyacooking.com/magazine/${ comment.article.slug }~${ comment.article.id }`" target="_blank">{{ comment.article.title }}</a></strong>
              </div>
              <div v-if="comment.ingredient" class="mb-3">
                <strong><a :href="`https://www.nyonyacooking.com/ingredients/${ comment.ingredient.slug }~${ comment.ingredient.id }`" target="_blank">{{ comment.ingredient.title }}</a></strong>
              </div>
              <div v-if="comment.replies_count > 0">
                <p>{{ comment.replies[comment.replies.length - 1].content }}</p>
                <div class="text-muted">
                  <small><router-link :to="{ name: 'users-id', params: { id: comment.replies[comment.replies.length - 1].user.id }}">{{ comment.replies[comment.replies.length - 1].user.name }}</router-link> commented {{ dateFromNow(comment.replies[comment.replies.length - 1].createdAt) }}</small>
                </div>
              </div>
              <div v-else>
                <p>{{ comment.content }}</p>
                <div class="text-muted">
                  <small><router-link :to="{ name: 'users-id', params: { id: comment.user.id }}">{{ comment.user.name }}</router-link> commented {{ dateFromNow(comment.createdAt) }}</small>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="!comments.length">
            <td class="text-muted" colspan="3">No comments were found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      loading: true,
      comments: [],
    }
  },

  mounted() {
    this.getComments()
  },

  methods: {
    async getComments() {
      this.loading = true

      try {
        var { data } = await this.$http.get(`/comments`, {
          params: { all: true },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.comments = data
    },

    dateFromNow(date) {
      return moment(date).fromNow()
    },
  },
}
</script>

<style>

</style>
